export default "skymp5-front/ffb48dba84edac2a01a89b25c3ba270e.mp3";